import { TextField } from '@mui/material';
import STATES from 'common-constants/states';
import ValidatedTextField from 'common-mui/components/ValidatedTextField';
import React from 'react';
import { useFormContext } from 'react-hook-form';

const InputAddressState = ({ prefill }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name="state"
      control={control}
      defaultValue={prefill || ''}
      rules={{
        required: 'This field is required.',
        validate: (value) => {
          if (value === 'MA') {
            return 'DigniFi is not available for residents in your state. We apologize for the inconvenience.';
          }
          return true;
        },
      }}
    >
      <TextField
        select
        fullWidth
        label="State"
        SelectProps={{ native: true }}
      >
        <option value="" disabled aria-label="blank option" />
        {STATES.map((state) => <option value={state} key={state}>{state}</option>)}
      </TextField>
    </ValidatedTextField>
  );
};

export default InputAddressState;
